import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle, ArrowLeft } from 'lucide-react';

/**
 * Payment Cancel Page
 * 
 * Shown when user cancels or abandons Stripe Checkout.
 * Provides clear path back to pricing or library.
 */
export default function PaymentCancelPage() {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-4">
      <Card className="max-w-md w-full bg-slate-900 border-slate-700">
        <CardContent className="pt-8 pb-8 text-center">
          <div className="mb-6">
            <div className="w-20 h-20 mx-auto bg-slate-800 rounded-full flex items-center justify-center">
              <XCircle className="h-12 w-12 text-slate-500" />
            </div>
          </div>
          
          <h1 className="text-2xl font-bold text-white mb-2">
            Payment Cancelled
          </h1>
          
          <p className="text-slate-400 mb-6">
            Your payment was cancelled. No charges were made to your account.
            You can try again whenever you're ready.
          </p>
          
          <div className="flex flex-col gap-3">
            <Button
              onClick={() => navigate('/pricing')}
              className="w-full bg-purple-600 hover:bg-purple-500"
              data-testid="return-to-pricing-btn"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Return to Pricing
            </Button>
            
            <Button
              variant="ghost"
              onClick={() => navigate('/reader/my-library')}
              className="text-slate-400 hover:text-white"
              data-testid="go-to-library-btn"
            >
              Go to Library
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
